import React from 'react';
import FilterableDatatable from "../../components/table/filterable-data-table";
import * as api from "../../api";
import ContractTradesStratsTableHeader from "./contract-trades-strats-table-header";
import ContractTradesStratsTableRow from "./contract-trades-strats-table-row";
import ArrayDataProvider from "../../components/table/data-providers/array-data-provider";

export default class ContractTradeStrats extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataProvider: new ArrayDataProvider([])
        };

        this.fetchData();
    }

    fetchData()
    {
        api.getContractTradingStrategiesList(this.props.customerId, this.props.contractId)
            .then(({data}) => this.state.dataProvider.updateDataSource(data));
    }

    render() {
        return (
            <FilterableDatatable dataProvider={this.state.dataProvider} name="contract-trade-strategies" canExport={true}
                                 refreshDataTrigger={this.state.dataProvider.onDataSourceChanged}
                                 headerComponent={ContractTradesStratsTableHeader} rowComponent={ContractTradesStratsTableRow} />
        );
    }
}